import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PasswordIcon from '@mui/icons-material/Password';

import { AuthContext } from '../../context/AuthContextProvider';
import { AppStateContext } from '../../context/AppStateContextProvider';
import PrimaryButton from '../../components/PrimaryButton';
import RoundedInput from '../../components/RoundedInput';
import AutoNavigate from '../../components/AutoNavigate';
import { defaultApiClient } from '../../apiClients/apiClient';

export default function VerifySignUpOtpPage() {
    const navigate = useNavigate();

    const { setTokens, signUpRequest, setSignUpRequest } = useContext(AuthContext);
    const { deviceFcmToken } = useContext(AppStateContext);

    const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [enteredOtp, setEnteredOtp] = useState('');

    const handleVerifyButtonClick = async () => {
        setIsVerifyingOtp(true);

        const loginResponse = await defaultApiClient.methods.auth.signup(
            enteredOtp,
            signUpRequest.fullName,
            signUpRequest.locality,
            phoneNumber
        );

        if (!loginResponse.success) {
            console.log(loginResponse);
            window.alert(
                `${loginResponse.error.userFriendlyError.title}: ${loginResponse.error.userFriendlyError.detail}`
            );
            setIsVerifyingOtp(false);
            return;
        }

        setTokens(loginResponse.result.tokens);
        setSignUpRequest(null);
        navigate('/');
    };

    useEffect(() => {
        if (signUpRequest !== null && signUpRequest.phoneNumber) {
            setPhoneNumber(signUpRequest.phoneNumber);
        }
    }, [signUpRequest]);

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/text-icon-high-res.png" style={{ height: '7vh' }} />
                <img src="/login.png" style={{ height: '35vh' }} />
            </Box>

            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: '80%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <RoundedInput
                        placeholder="Enter phone number"
                        icon={<LocalPhoneIcon />}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        type="tel"
                        disabled={true}
                    />
                </Box>

                <Box
                    sx={{
                        width: '80%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <RoundedInput
                        placeholder="Enter OTP"
                        icon={<PasswordIcon />}
                        value={enteredOtp}
                        onChange={(e) => setEnteredOtp(e.target.value)}
                        type="number"
                    />
                </Box>

                <PrimaryButton
                    text="Continue"
                    fontSizeOverride={16}
                    onClick={handleVerifyButtonClick}
                />
            </Box>
        </Box>
    );
}
